var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShortTimeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 493,
    viewBox: "0 0 409 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1.5,
    x2: 374,
    y2: 1.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 36.5,
    x2: 389,
    y2: 36.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 71.5,
    x2: 389,
    y2: 71.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 106.5,
    x2: 389,
    y2: 106.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 141.5,
    x2: 389,
    y2: 141.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 176.5,
    x2: 343,
    y2: 176.5,
    stroke: "#6013FB",
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 211.5,
    x2: 389,
    y2: 211.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 246.5,
    x2: 389,
    y2: 246.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 281.5,
    x2: 389,
    y2: 281.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 316.5,
    x2: 389,
    y2: 316.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 351.5,
    x2: 374,
    y2: 351.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 386.5,
    x2: 389,
    y2: 386.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 421.5,
    x2: 389,
    y2: 421.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 456.5,
    x2: 389,
    y2: 456.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 491.5,
    x2: 389,
    y2: 491.5,
    stroke: "#120232",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortTimeline);
export default __webpack_public_path__ + "static/media/ShortTimeline.ef91bc91.svg";
export { ForwardRef as ReactComponent };